import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface RemoveItemFromCartMutationObject {
  mutation: {
    removeItemFromCart: {
      __args: {
        input: {
          cart_id: string
          cart_item_id: number
          [key: string]: any
        }
      }
      [key: string]: any
    }
  }
}

export const removeItemFromCartMutationObject = {
  mutation: {
    removeItemFromCart: {
      __args: {
        input: {
          cart_id: '',
          cart_item_id: 0
        }
      }
    }
  }
}

interface RemoveItemFromCartMutationInput {
  cartId: string
  cartItemId: string
}

export type RemoveItemFromCartMutation = (input: RemoveItemFromCartMutationInput) => Promise<FetchResult<any>>

export const createRemoveItemFromCartMutation = ({ getMutations, getQueries }: ServiceDependencies): RemoveItemFromCartMutation => async ({ cartId, cartItemId }) => {
  const queries = getQueries()
  const mutation = getMutations().removeItemFromCartMutation
  mutation.mutation.removeItemFromCart.__args.input.cart_id = cartId
  mutation.mutation.removeItemFromCart.__args.input.cart_item_id = parseInt(cartItemId)
  mutation.mutation.removeItemFromCart = {
    ...mutation.mutation.removeItemFromCart,
    cart: {
      ...queries.cartQuery,
      ...queries.cartPrices,
      ...queries.shippingAddresses,
      ...queries.billingAddresses,
      ...queries.cartAppliedCoupon
    }
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`,
    fetchPolicy: 'no-cache'
  })
}
